import { useContext } from "react";
import { AuthContext } from "../auth-context";
import IODate from "../widget/io-date";
import IOImage from "../widget/io-image";
import IOList from "../widget/io-list";
import IOPanelWithNavigation from "../widget/io-panel-with-navigation";
import IOString from "../widget/io-string";
import IOText from "../widget/io-text";
import Panel from "../widget/panel";
import TwoColumns from "../widget/two-columns";
import type { Patient, Picture } from "./_objects-patient";
import { type RelatedElementGeneratorProps } from "./patient-related-element-generator";

export default function PictureElement(
  props: { patient: Patient } & RelatedElementGeneratorProps<Picture>
): React.ReactNode {
  const authenticationContext = useContext(AuthContext)!;

  return (
    <IOPanelWithNavigation<Picture>
      {...props}
      key={`picture.${props.file.id}`}
      type="picture"
      apiRootUrl={`/api/patient/${props.patient.id}/picture`}
      restrictedForWrite="write"
      restrictedForUnlock="manage_archives"
      canBeLocked={true}
      basePath={`${props.parentPath}/picture`}
      header={<>{props.file.type}</>}
    >
      <TwoColumns>
        <Panel fixed label="Information">
          <input
            type="hidden"
            name="patient_id"
            defaultValue={props.patient.id}
          />
          <IOList
            name="type"
            value={props.file.type}
            list={authenticationContext.getList("PictureType")}
          />
          <IODate name="date" value={props.file.date} required />
          <IOString label="File" value={props.file.file} e2eExcluded />
          <IOText name="comments" value={props.file.comments} />
        </Panel>
        <Panel fixed label="Image">
          <IOImage
            name="fileBlob"
            label="Picture"
            value={`/api/patient/${props.patient.id}/picture/${props.file.id ?? ""}/image`}
            required
            create={!props.file.id}
          />
        </Panel>
      </TwoColumns>
    </IOPanelWithNavigation>
  );
}
